export default "__VITE_ASSET__8fe4bca1__"